// Startpunkt CSS
import '../css/index.scss';

import jquery from 'jquery';
window.$ = window.jQuery = jquery;
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import Autocomplete from "bootstrap5-autocomplete";

// Proj4
import proj4 from "proj4";
import {register} from "ol/proj/proj4";

proj4.defs('EPSG:25832', '+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs');
register(proj4);

// OpenLayers
import {Map, Overlay, View} from "ol";
import {defaults as defaultControls, MousePosition, ScaleLine} from "ol/control";
import VectorLayer from "ol/layer/Vector";
import {TileWMS} from "ol/source";
import {gdGetVectorSource} from "./gd-ol-functions";
import {gdGetTimestamp} from "./gd-functions";
import TileLayer from "ol/layer/Tile";
import {createStringXY} from "ol/coordinate";
import {GdControls} from "./custom-ol/GdControls";
import {GdLayerPicker} from "./custom-ol/GdLayerPicker";
import GdFeatureInfoControl from "./custom-ol/GdFeatureInfoControl";
import {Point} from "ol/geom";


const gdExtent = [358099,5609367, 375298, 5628262]; // Extent Bonn
const gdCenter = [366216.506, 5622353.327]; // Center Bonn
const gdMinZoom = 12;
let gdTimestamp = gdGetTimestamp();
let gdRes = null;





const gdMap = new Map({
    layers: [],
    target: 'gdMap',
    view: new View({
        projection: 'EPSG:25832',
        center: gdCenter,
        extent: gdExtent,
        showFullExtent: true,
        zoom: 10
    }),
    controls: defaultControls({
        zoomOptions: {
            target: 'gdControls'
        },
        attributionOptions: {
            collapsible: false
        }
    }).extend([
        new ScaleLine({
            target: 'gdScaleBar',
            units: 'metric',
            bar: true,
            steps: 2,
            text: true,
            minWidth: 140
        }),
        new MousePosition({
            target: 'gdMousePosition',
            coordinateFormat: createStringXY(2),
            className: 'ol-mouse-position',
            undefinedHTML: '&nbsp;',
        })
    ])
})

const gdControls = new GdControls(gdMap, gdBgConfig);
const layerPicker = new GdLayerPicker(gdMap, gdBgConfig);

//const gdFeatureInfoControl = new GdFeatureInfoControl(gdMap, gdAdresseGefoerdertLayer);


//gdMap.on('moveend', function (evt) {
//    let view = evt.map.getView(),
        //extent = view.calculateExtent(),
//        gdRes = view.getResolution();
//});




$(document).ready(function() {
    const gdModal = new bootstrap.Modal('#gdModal');
    gdModal.show();

    gdPopup = new Overlay({
        element: document.getElementById('gdPopup')
    });
    gdMap.addOverlay(gdPopup);

    $('#gdAutocomplete').on('click focusin', function() {
        this.value = '';
    });
    const gdAutocomplete = new Autocomplete(document.getElementById('gdAutocomplete'), {
        suggestionsThreshold: 3,
        fullWidth: true,
        fixed: true,
        fillIn: true,
        notFoundMessage: 'kein Treffer',
        //onServerResponse: function (dd) {
        //    console.log('serverResponse', dd);
        //},
        onSelectItem: function (item) {

            $.ajax(
                '/suche/position/' + item.value,
            ).done(function (response) {
                if (response.length == 2) {
                    const point = new Point([response[0], response[1]]);
                    //var feature = new Feature({
                    //    geometry: point
                    //});
                    //drawLayer.getSource().addFeature(feature);
                    gdMap.getView().fit(point, {maxZoom: 19, padding: [20, 20, 20, 20]});
                }
            });
        }
    })
});